module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaCAYAAACHD21cAAAAAXNSR0IArs4c6QAAAMFJREFUOBGd1DsOwyAMANAAuU+XTlG3nqDq1hkOBYK1W9UTdM3WE1VAcaRETcLHrgeMLJ7wYLlzzh2MMUNHDB5C6GOMT2vtmWK5UuqdwNV7f6dgNv+itT6l+0MIcZNSvuZ6KS8QHlDwClLwDmJxFmJwEbZwFdZwE5YwCuYwGv5ixtiFQ+Gf6LFoM1UjqtUNmua4CXMIuqzCEqrCGirCFspCDNpBLFpBClogFQHkaa8eU0YvKUAQMHIfGNq02capgjy+wyJ/TEovuXwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/arrow-right.png
// module id = 795
// module chunks = 106